import React from "react";
import { Form } from "@redriver/cinnamon";
import { getAddressTypes } from "./actions";

export const AddressTypesDropdown = (props) => (
  <Form.Dropdown {...props} lookupAction={getAddressTypes} />
);

export default AddressTypesDropdown;
